import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=0532a6d4&"
import script from "./ContactBox.vue?vue&type=script&lang=js&"
export * from "./ContactBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports